.shelf {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, var(--shelf-item-min, 280px)), 1fr));
  gap: var(--space-8) var(--space-5);
}

.item {
  position: relative;
  display: grid;
  grid-row: span 2;
  grid-template-rows: subgrid;
  row-gap: var(--space-3);
  min-width: 0;
}

.visual {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  min-width: 0;
  /* Pictures are capped in height so one tall poster does not stretch the whole row. */
  --image-max-height: var(--shelf-visual-max-height, 280px);
}

.body {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
